<template>
  <transition name="slide">
    <b-navbar toggleable fixed="top" variant="faded" v-bind:class="headerClassBindings">
      <div class="container app-header-container">
        <b-nav-toggle target="scroll-app-header-nav-collapse" class="clickable"></b-nav-toggle>
        <b-link class="navbar-brand app-brand" to="/intro" v-if="attachHome">
          <img src="/static/images/ic-classting-logo.svg">
        </b-link>
        <b-link class="navbar-brand app-brand" to="/library" v-else>
          <img src="/static/images/ic-classting-logo.svg">
        </b-link>

        <b-collapse is-nav id="scroll-app-header-nav-collapse">
          <b-nav is-nav-bar class="mx-auto">
            <b-nav-item to="/library">{{ $t('header.nav_menu.library') }}</b-nav-item>
            <b-nav-item to="/my-cards">{{ $t('header.nav_menu.my_cards') }}</b-nav-item>
            <b-nav-item to="/publishers" v-if="isPublisherUser">{{ $t('header.nav_menu.publishers') }}</b-nav-item>
            <b-nav-item to="/video-courses" v-if="isPublisherUser">{{ $t('header.nav_menu.video_lectures') }}</b-nav-item>
          </b-nav>

          <b-nav is-nav-bar class="hidden-sm-down">
            <a v-bind:href="userProfileUrl" target="_blank" class="btn rounded-circle profile-btn" v-bind:style="styleBindings"></a>
          </b-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { CLASSTING_URL } from '@/config';

  export default {
    name: 'scroll-app-header',

    props: {
      attachHome: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        isPinned: false,
      };
    },

    computed: {
      ...mapGetters([
        'isPublisherUser',
        'currentUser',
        'isKrUser',
      ]),

      userProfileUrl() {
        return `${CLASSTING_URL}/users/${this.currentUser.id}`;
      },

      headerClassBindings() {
        return {
          'header--unpinned': !this.isPinned,
          'header--pinned': this.isPinned,
          'scroll-app-header': true,
          'app-header': true,
          'bs-b': true,
        };
      },

      styleBindings() {
        if (this.currentUser) {
          return {
            'background-image': `url('${this.currentUser.profile_image}')`,
          };
        }

        return {};
      },
    },

    mounted() {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 250) {
          this.isPinned = true;
        } else {
          this.isPinned = false;
        }
      });
    },
  };
</script>

<style lang="scss">
  .slide-enter, .slide-leave-to {
    transform: translateY(0%);
  }

  .scroll-app-header {
    will-change: transform;
    transition: transform 300ms linear;
    top: -200px;

    @media print {
      display: none !important;
    }
  }

  .header--pinned {
    transform: translateY(200px);
  }

  .header--unpinned {
    transform: translateY(0px);
  }
</style>



// WEBPACK FOOTER //
// src/components/ScrollAppHeader.vue